import * as i0 from '@angular/core';
import * as i1 from './select.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@vltansky/ng-select';
import * as i5 from '../hint/hint.directive';
import * as i6 from '../tooltip/tooltip.component';
import * as i7 from './select.component';
import * as i8 from '../hint/hint.module';
import * as i9 from '../tooltip/tooltip.module';
export const BllSelectModuleNgFactory:i0.NgModuleFactory<i1.BllSelectModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_ba = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.FormControlDirective = (<any>(null as any));
var _decl0_33:i3.FormGroupDirective = (<any>(null as any));
var _decl0_34:i3.FormControlName = (<any>(null as any));
var _decl0_35:i3.FormGroupName = (<any>(null as any));
var _decl0_36:i3.FormArrayName = (<any>(null as any));
var _decl0_37:i4.NgSelectComponent = (<any>(null as any));
var _decl0_38:i4.ɵr = (<any>(null as any));
var _decl0_39:i4.ɵg = (<any>(null as any));
var _decl0_40:i4.ɵf = (<any>(null as any));
var _decl0_41:i4.ɵh = (<any>(null as any));
var _decl0_42:i4.ɵi = (<any>(null as any));
var _decl0_43:i4.ɵj = (<any>(null as any));
var _decl0_44:i4.ɵk = (<any>(null as any));
var _decl0_45:i4.ɵl = (<any>(null as any));
var _decl0_46:i4.ɵm = (<any>(null as any));
var _decl0_47:i4.ɵn = (<any>(null as any));
var _decl0_48:i4.ɵo = (<any>(null as any));
var _decl0_49:i4.ɵp = (<any>(null as any));
var _decl0_50:i5.BllHintDirective = (<any>(null as any));
var _decl0_51:i6.BllTooltipComponent = (<any>(null as any));
var _decl0_52:i7.BllSelectComponent = (<any>(null as any));
var _decl0_53:i2.AsyncPipe = (<any>(null as any));
var _decl0_54:i2.UpperCasePipe = (<any>(null as any));
var _decl0_55:i2.LowerCasePipe = (<any>(null as any));
var _decl0_56:i2.JsonPipe = (<any>(null as any));
var _decl0_57:i2.SlicePipe = (<any>(null as any));
var _decl0_58:i2.DecimalPipe = (<any>(null as any));
var _decl0_59:i2.PercentPipe = (<any>(null as any));
var _decl0_60:i2.TitleCasePipe = (<any>(null as any));
var _decl0_61:i2.CurrencyPipe = (<any>(null as any));
var _decl0_62:i2.DatePipe = (<any>(null as any));
var _decl0_63:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_64:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_65:i2.KeyValuePipe = (<any>(null as any));
var _decl0_66:i2.CommonModule = (<any>(null as any));
var _decl0_67:i3.FormsModule = (<any>(null as any));
var _decl0_68:i3.ReactiveFormsModule = (<any>(null as any));
var _decl0_69:i4.NgSelectModule = (<any>(null as any));
var _decl0_70:i8.BllHintModule = (<any>(null as any));
var _decl0_71:i9.BllTooltipModule = (<any>(null as any));
var _decl0_72:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_73:i0.ElementRef<any> = (<any>(null as any));
function _View_BllSelectComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_52.inline;
  currVal_0;
}
function _View_BllSelectComponent_1_2():void {
  if (!!_any.hint) {
    var _any:any = (null as any);
    const currVal_0:any = _any.hint;
    currVal_0;
    const currVal_1:any = _decl0_51.id;
    currVal_1;
    const currVal_2:any = (-1);
    currVal_2;
  }
}
function _View_BllSelectComponent_1_1():void {
  var _any:any = (null as any);
  const currVal_0:any = (_any[_decl0_52.bindLabel] || _any);
  currVal_0;
  const currVal_1:any = (_any[_decl0_52.bindLabel] || _any);
  currVal_1;
  const currVal_2:any = !!_any.hint;
  currVal_2;
}
function _View_BllSelectComponent_1_3():void {
  if ((!_decl0_52.hideErrorMsg && (_decl0_52.errorMsg || _decl0_52.placeholder))) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_52.errorMsg || _decl0_52.placeholder);
    currVal_0;
  }
}
function _View_BllSelectComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_52.bindLabel;
  currVal_0;
  const currVal_1:any = _decl0_52.bindValue;
  currVal_1;
  const currVal_2:any = _decl0_52.placeholder;
  currVal_2;
  const currVal_3:any = 'body';
  currVal_3;
  const currVal_4:any = _decl0_52.loading;
  currVal_4;
  const currVal_5:any = _decl0_52.disabled;
  currVal_5;
  const currVal_6:any = _decl0_52.searchable;
  currVal_6;
  const currVal_7:any = _decl0_52.clearable;
  currVal_7;
  const currVal_8:any = _decl0_52.items;
  currVal_8;
  const currVal_9:any = _decl0_37.useDefaultClass;
  currVal_9;
  const currVal_10:any = !_decl0_37.multiple;
  currVal_10;
  const currVal_11:any = _decl0_37.typeahead;
  currVal_11;
  const currVal_12:any = _decl0_37.multiple;
  currVal_12;
  const currVal_13:any = _decl0_37.addTag;
  currVal_13;
  const currVal_14:any = _decl0_37.searchable;
  currVal_14;
  const currVal_15:any = _decl0_37.clearable;
  currVal_15;
  const currVal_16:any = _decl0_37.isOpen;
  currVal_16;
  const currVal_17:any = _decl0_37.disabled;
  currVal_17;
  const currVal_18:any = _decl0_37.filtered;
  currVal_18;
  const currVal_19:any = _decl0_52.selected;
  currVal_19;
  const currVal_20:any = _decl0_21.is('untouched');
  currVal_20;
  const currVal_21:any = _decl0_21.is('touched');
  currVal_21;
  const currVal_22:any = _decl0_21.is('pristine');
  currVal_22;
  const currVal_23:any = _decl0_21.is('dirty');
  currVal_23;
  const currVal_24:any = _decl0_21.is('valid');
  currVal_24;
  const currVal_25:any = _decl0_21.is('invalid');
  currVal_25;
  const currVal_26:any = _decl0_21.is('pending');
  currVal_26;
  const currVal_27:any = _decl0_52.isEnglish;
  currVal_27;
  const currVal_28:any = _decl0_52.hideIcon;
  currVal_28;
  const currVal_29:any = (!_decl0_52.hideErrorMsg && (_decl0_52.errorMsg || _decl0_52.placeholder));
  currVal_29;
  const pd_30:any = ((<any>_decl0_37.handleKeyDown(_any)) !== false);
  const pd_31:any = ((<any>(_decl0_52.selected = _any)) !== false);
  const pd_32:any = ((<any>_decl0_52.onChange(_any)) !== false);
}
